import { logger } from 'ls-common-client';
import config from './config';

const instance = logger.create({
  debug: config.debug,
});

export default instance;
